import { Checkbox, FormControlLabel } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { getContractStatusCms } from 'app/modules/cms/service/store/selectors';
import ActionComponent from 'app/shared/components/common/action-component';
import { InputLounge } from 'app/shared/components/common/input/lounge-input';
import TransitionsModal from 'app/shared/components/common/modal/modal';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { getDate } from 'app/shared/util/date-utils';
import { Markup } from 'interweave';
import React from 'react';
import { useSelector } from 'react-redux';
import ContractDetails from '../desktop-assignement-contract/contract-details';
import './style.scss';

const DesktopSearchContract = props => {
  const {
    accoutAssignementCms,
    loadingCheckMail,
    selectedContract,
    dataConf,
    showModel,
    setShowModel,
    avatar,
    checked,
    chekedFunc,
    mailValue,
    setMailValue,
    dispatchor,
    mailChecked,
    redirectFoundSubs,
    subNumber,
    handleChange,
    redirect,
    disabledSearchButton,
    handleMaxTry
  } = props;

  const contractCustomerCms: any = useSelector(getContractStatusCms);
  return (
    <div className="desktop-search-adhesion p-2 h-100">
      {showModel &&
        <TransitionsModal
          showModal={showModel}
          setShowModel={setShowModel}
          textBody={accoutAssignementCms?.search_contract?.search_modal_error}
        />
      }
      <div className="search-contracts-form">
        {selectedContract ?
          <AvatarWithBadge hideButton title={[accoutAssignementCms?.search_contract?.avatar_text]} avatar={avatar} />
          :
          <AvatarWithBadge hideButton title={[accoutAssignementCms?.main_avatar_text]} avatar={avatar} />
        }
        {selectedContract ?
          <>
            <div className="insured-desktop-list">
              <ContractDetails
                subscription={selectedContract?.number}
                startDate={getDate(selectedContract?.startDate)}
                phoneNumber={selectedContract?.tel}
                imei={selectedContract?.imei}
                accoutAssignementCms={accoutAssignementCms}
                contractCustomerCms={contractCustomerCms}
                status={selectedContract?.status}
                brand={selectedContract?.brand}
                model={selectedContract?.model}
              />
            </div>
            {!selectedContract?.valid ?
              <>
                <div className='d-flex justify-content-start'>
                  <FormControlLabel control={<Checkbox checked={checked} onChange={chekedFunc} color="primary" className="pr-2" />} label={accoutAssignementCms?.search_contract?.checkbox_label} />
                </div>
                <div className='d-flex justify-content-end'>
                  <ActionComponent
                    label={accoutAssignementCms?.search_contract?.btn_next_label}
                    style={'Mobile1'}
                    action={'NEXT_STEP_SEARCH'}
                    ActionData={dataConf.actioDataList}
                    param={{ specificAction: redirectFoundSubs }}
                  />
                </div>
              </>
              :
              <div className="w-100">
                <div className="d-flex text-style align-items-center w-100">
                  <ErrorOutline className="mt-0 mr-1 " />
                  {accoutAssignementCms?.search_contract?.error_text}
                </div>
                <div className="text-style ">
                  <div className="d-flex flex-column my-2">
                    <span className="pl-1"> {accoutAssignementCms?.search_contract?.email_input_label} </span>
                    <InputLounge
                      value={mailValue}
                      action={e => setMailValue(e.target.value)}
                      showLabel={false}
                      placeholder={accoutAssignementCms?.search_contract?.email_input_placeholder}
                      label={accoutAssignementCms?.search_contract?.email_input_placeholder}
                      style="info-client-input mail-input"
                      required
                    />
                    {mailChecked === true ?
                      <Alert className="w-100 mt-2 d-flex align-items-end" severity="success">
                        {accoutAssignementCms?.search_contract?.email_alert}
                      </Alert>
                      : mailChecked === false ?
                        <Alert className="w-100 mt-2 d-flex align-items-end" severity="error">
                          {accoutAssignementCms?.search_contract?.email_error_alert}
                        </Alert>
                        :
                        <></>
                    }
                    <br />
                    <div className="d-flex justify-content-center">
                      {mailChecked === true ?
                        <ActionComponent
                          label={accoutAssignementCms?.search_contract?.btn_next_label}
                          style={'Mobile1'}
                          action={'NEXT_STEP_SEARCH'}
                          ActionData={dataConf.actioDataList}
                          param={{ specificAction: redirectFoundSubs }}
                        />
                        :
                        <ActionComponent
                          label={accoutAssignementCms?.search_contract?.btn_valid_label}
                          style={'Mobile1'}
                          action={'VERIF_PREVIOUS_MAIL_ACTION'}
                          loading={loadingCheckMail}
                          ActionData={dataConf.actioDataList}
                          param={{ dispatchor, number: selectedContract?.number, mailValue }}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </>
          :
          <>
            <div className="w-100 mt-3">
              {(selectedContract !== null && !selectedContract) &&
                <div className="w-100">
                  <div className="error-text"><Markup content={accoutAssignementCms?.search_contract?.no_correspondance_subscription} /></div>
                </div>
              }
              <InputLounge
                value={subNumber}
                action={e => handleChange(e.target.value)}
                placeholder={accoutAssignementCms?.input_search_placeholder}
                label={accoutAssignementCms?.input_search_placeholder}
                style={'info-client-input'}
                icon={accoutAssignementCms?.input_search_icone}
                showLabel={false}
                tooltipIcon={accoutAssignementCms?.tooltip_icon}
                tooltipText={accoutAssignementCms?.tooltip_text}
              />

              <div className="d-flex justify-content-end">
                <ActionComponent
                  label={accoutAssignementCms?.btn_search_label}
                  style={'Mobile1'}
                  action={'SUBSCRIPTION_SEARCH'}
                  ActionData={dataConf.actioDataList}
                  param={{ specificAction: redirect }}
                  disabledProp={disabledSearchButton}
                />
              </div>
              <div className="search-contact-us-link">
                <p>{accoutAssignementCms?.search_contract?.search_contact_us_label} <span onClick={() => handleMaxTry()}>{accoutAssignementCms?.search_contract?.search_contact_us_link_label}</span></p>
              </div>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default DesktopSearchContract;
